import React from "react";
import { Container, Row, Col } from "shards-react";
import MUIDataTable from "mui-datatables";
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';

import api from '../common/api'

  //import { Store } from "../../flux";
  
class ClientAudit extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        param:'',
        client_id: '',
        client_name: '',
        isLoaded: false,
      }
    }

    async componentDidMount() {
      const param = this.getParams()
      var client_id = param.id
      await this.getAudit(client_id);
      await this.getClient(client_id);
      this.setState({client_id: client_id});

    }
   
   getParams(location) {
      return this.props.match.params
   } 

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.8rem'
         }
        },
        MuiSvgIcon:{
          root: {
            fontSize: "1.39rem"
          }
        },
        MuiFab:{
          sizeSmall:{
            height: "35px",
            width: "35px"
          }
        }
      }
    });     

   getAudit = (client_id) => {
     const token = localStorage.getItem('userToken')

     return axios
              .get(api.clients().audit(client_id),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                let audit = []
                res.data.client.map((val,idx)=>{
                  audit.push(val)
                })
                if (res.data.address !== undefined){
                  res.data.address.map((val, idx)=>{
                    if (val.audit.length !== 0){
                      audit.push(val.audit)
                    }
                  })
                }
                if (res.data.client_structures !== undefined){
                  res.data.client_structures.map((val, idx)=>{
                    if (val.audit[0] !== undefined){
                      audit.push(val.audit[0])
                    }
                  })
                }
                if (res.data.taxes.length !== 0){
                  audit.push(res.data.taxes[0])
                }
                if (res.data.subcontacts !== undefined){
                  res.data.subcontacts.map((val, idx)=>{
                    if (val.audit[0] !== undefined && val.audit[0].length !== 0){
                      audit.push(val.audit[0])
                    }
                  })
                }
                if (res.data.audits !== undefined){
                  res.data.audits.map((val, idx)=>{
                    if (val.audit !== undefined){
                      audit.push(val.audit[0])
                    }
                  })
                }
                this.setState({isLoaded: true, data: audit})
              })
              .catch(err =>{console.log(err)
              })

    }

  getClient(client_id){
   const token =localStorage.getItem('userToken')

    return axios
         .get(api.clients().get(client_id),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              this.setState({client_name: res.data[0].business_name})
          })
          .catch(err =>{console.log(err)
          })
  }



  render(){
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
       sortDirection: 'asc' 
      }
     },
     {
      name: "event",
      label: "Evento",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "user_id",
      label: "Usuario",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "old_values",
      label: "valores anteriores",
      options: {
       filter: false,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
            return (  
                <div>{JSON.stringify(value)}</div>
              );
          }
      }
     },
     {
      name: "new_values",
      label: "Nuevos valores",
      options: {
       filter: false,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
            return (  
                <div>{JSON.stringify(value)}</div>
              );
          }
      }
     },
     {
      name: "created_at",
      label: "Fecha",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     }
    ];

  const options = {
    download: true,
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    rowsPerPage: 10,
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
            downloadCsv: "Exportar a CSV"        
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
      <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title={`Auditoría ${this.state.client_name}`}
                  data={Object.values(this.state.data)}
                  columns={columns}
                  options={options}
                 />

                <div style={{textAlign: "right"}}>
                   <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/clients"}>
                      Volver
                  </Button>
                </div>
              </MuiThemeProvider>
            </Col>
          </Row>
         </Container>

    );
  }


}

export default ClientAudit;   